import gql from 'graphql-tag';
import React from 'react';

import {MoleculeCanonicalSmilesQuery} from 'chemistry/molecules/tabs/__generated/MoleculeCanonicalSmilesQuery';
import {MoleculeFieldRow, MoleculeInaccessibleMessage} from 'chemistry/molecules/tabs/MoleculeStructureField';
import BenchlingQuery from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import getTestProps from 'test/lib/cypress/getTestProps';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

export const MOLECULE_CANONICAL_SMILES_QUERY = gql`
  query MoleculeCanonicalSmilesQuery($moleculeId: StrictString!, $moleculeVersionId: StrictString!)
  @skipAudit
  @engComponent(name: CHEMISTRY) {
    molecule(id: $moleculeId) {
      ... on MoleculeNode {
        id
        version(versionId: $moleculeVersionId) {
          id
          chemicalStructure {
            id
            canonicalSmiles
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

interface MoleculeCanonicalSmilesProps {
  moleculeId: string;
  moleculeVersionId: string;
}

export default function MoleculeCanonicalSmiles(props: MoleculeCanonicalSmilesProps): JSX.Element | null {
  return (
    <BenchlingQuery
      query={MOLECULE_CANONICAL_SMILES_QUERY}
      variables={{moleculeId: props.moleculeId, moleculeVersionId: props.moleculeVersionId}}
      renderLoading={() => <CenteredHorizontalThrobber />}
    >
      {(data: MoleculeCanonicalSmilesQuery) => {
        if (isInaccessible(data.molecule)) {
          return <MoleculeInaccessibleMessage />;
        }
        const canonicalSmiles = data.molecule.version
          ? data.molecule.version.chemicalStructure.canonicalSmiles
          : 'Chemical structure for this version not found';
        return (
          <MoleculeFieldRow
            label="Canonical SMILES"
            withTopSpacing={true}
            valueProps={{
              ...getTestProps({component: 'MoleculeChemicalStructure', element: 'canonicalSmiles'}),
            }}
          >
            {canonicalSmiles}
          </MoleculeFieldRow>
        );
      }}
    </BenchlingQuery>
  );
}
